import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';

const CompanyDirector = ({ values }) => (
  <Content>
    {({
      globalRadioError = '',
      personDetailsCompanyDirector = '',
      radioFieldYes,
      radioFieldNo
    }) => (
      <Field
        name="companyDirector"
        subscription={{ touched: true, error: true }}
        validate={isRequired}
      >
        {({ meta: { touched, error }, input }) => (
          <GenericFieldWrapper
            inputId="companyDirector"
            title={personDetailsCompanyDirector}
            validationMessage={touched && !!error ? globalRadioError : ''}
          >
            <GenericRadio.InlineSet
              groupName="companyDirector"
              items={[
                {
                  id: radioFieldYes,
                  labelText: radioFieldYes
                },
                {
                  id: radioFieldNo,
                  labelText: radioFieldNo
                }
              ]}
              {...input}
              selectedId={values.companyDirector}
              onChange={selectedId => {
                input.onChange(selectedId);
              }}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default CompanyDirector;
